import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CampaignManagerOffersModel } from './campaign-v2-offers.model';

export interface CampaignV2OffersState extends EntityState<CampaignManagerOffersModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'campaign-v2-offers', idKey: 'MemberID', cache: { ttl: 30000 } })
export class CampaignV2OffersStore extends EntityStore<CampaignV2OffersState> {
  constructor() {
    super();
  }
}
